export const FLEET_KEY = 'fleet';

// Show search in the yachts menu only when the list is long
export const SCOPE_SEARCH_MIN_ITEMS = 8;
